import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Layout from "./layout/Layout";

// Core pages
import Website from "./pages/Website";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Policies from "./pages/Policies";

// Alarm pages
import Alarms from "./pages/Alarms";
import Ajax from "./pages/Ajax";
import AlarmMonitoring from "./pages/AlarmMonitoring";
import AlarmMaintenance from "./pages/AlarmMaintenance";
import AlwaysConnected from "./pages/AlwaysConnected";
import SmartHome from "./pages/SmartHome";

// Ajax Products
import StarterKit from "./pages/Ajax/StarterKit";
import IntrusionDetection from "./pages/Ajax/IntrusionDetection";

// Keyholding
import Keyholding from "./pages/Keyholding";
import KeyholdingFAQ from "./pages/KeyholdingFAQ";
import KeyholdingTerms from "./pages/KeyholdingTerms";
import KeyholdingPolicies from "./pages/KeyholdingPolicies";

// TP-Link
import TpLink from "./pages/TpLink/TpLink";
import TapoAlexaGoogle from "./pages/TpLink/TapoAlexaGoogle";
import TapoDeco from "./pages/TpLink/TapoDeco";
import TapoLighting from "./pages/TpLink/TapoLighting";
import TapoCameras from "./pages/TpLink/TapoCameras";
import TapoPower from "./pages/TpLink/TapoPower";
import TapoSmartHubs from "./pages/TpLink/TapoSmartHubs";
import TapoSmartPlugs from "./pages/TpLink/TapoSmartPlugs";
import TapoMatter from "./pages/TpLink/TapoMatter";
import TapoApp from "./pages/TpLink/TapoApp";

// Context
import { PopupProvider } from "./context/PopupContext";

export default function App() {
  return (
    <HelmetProvider>
      <PopupProvider>
        <Routes>
          <Route element={<Layout />}>

            {/* Home */}
            <Route index element={<Website />} />

            {/* Core */}
            <Route path="services" element={<Services />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="policies" element={<Policies />} />

            {/* Alarm Systems */}
            <Route path="alarms" element={<Alarms />} />
            <Route path="alarms/ajax" element={<Ajax />} />
            <Route path="alarms/monitoring" element={<AlarmMonitoring />} />
            <Route path="alarms/always-connected" element={<AlwaysConnected />} />
            <Route path="alarms/maintenance" element={<AlarmMaintenance />} />

            {/* Ajax Products */}
            <Route
              path="alarms/ajax/intrusion-detection"
              element={<IntrusionDetection />}
            />
            <Route
              path="alarms/ajax/starter-kit"
              element={<StarterKit />}
            />

            {/* Smart Home */}
            <Route path="smarthome" element={<SmartHome />} />

            {/* Keyholding */}
            <Route path="secure-keyholding" element={<Keyholding />} />
            <Route
              path="secure-keyholding/faq"
              element={<KeyholdingFAQ />}
            />
            <Route
              path="secure-keyholding/terms"
              element={<KeyholdingTerms />}
            />
            <Route
              path="secure-keyholding/policies"
              element={<KeyholdingPolicies />}
            />

            {/* TP-Link */}
            <Route path="tplink" element={<TpLink />} />
            <Route path="tplink/alexa-google" element={<TapoAlexaGoogle />} />
            <Route path="tplink/deco" element={<TapoDeco />} />
            <Route path="tplink/lighting" element={<TapoLighting />} />
            <Route path="tplink/cameras" element={<TapoCameras />} />
            <Route path="tplink/power" element={<TapoPower />} />
            <Route path="tplink/smarthubs" element={<TapoSmartHubs />} />
            <Route path="tplink/smartplugs" element={<TapoSmartPlugs />} />
            <Route path="tplink/matter" element={<TapoMatter />} />
            <Route path="tplink/app" element={<TapoApp />} />

          </Route>
        </Routes>
      </PopupProvider>
    </HelmetProvider>
  );
}
